import { UpdateAccountRequestBody } from "@syla/shared/types/requests/UpdateAccountRequest";
import axios from "axios";
import { checkStatusAndDoPendingWork } from "../../store/pendingWork";
import { Account } from "../../types/Account";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function updateAccount(
  accountId: string,
  newProps: UpdateAccountRequestBody,
): Promise<Account> {
  try {
    const { data } = await axios.patch(`/accounts/${accountId}`, newProps);
    checkStatusAndDoPendingWork();
    return data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
